import axios from 'axios';
import { useDispatch } from 'react-redux';
import { printToast } from '../core/utils/Global.js';
import { GetToken, isExpiredToken, logout, setToken } from './Auth.js';
import Shareds from './translations/Shareds.js';

export const errosTratados = [400, 401, 403];

export const axiosErrorShow = (error, dec = null) => {
    switch (error.response.status) {
        case 400:
            if (error.response.data.message) {
                printToast({
                    severity: 'error',
                    summary: Shareds.request.error400.title,
                    detail: error.response.data.message,
                });
            }

            break;
        case 401:
            if (isExpiredToken()) {
                printToast({
                    severity: 'error',
                    summary: Shareds.login.sessaoExpirada,
                    detail: '',
                });
                logout();
                window.location.reload();
            }
            break;
        case 403:
            printToast({
                severity: 'error',
                summary: Shareds.request.error403.title,
                detail: error.response.data.message,
            });

            break;
        default:
            return dec(), Promise.reject(error);
    }
    return dec(), Promise.reject(error);
};

export const useAxiosLoader = () => {
    const routesNotShowLoader = ['pessoas/auto-complete', 'orgaos/auto-complete'];

    const Axios = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
    });

    const dispatch = useDispatch();

    const inc = () => {
        dispatch({ type: 'counterRequest/increment' });
    };
    const dec = () => {
        dispatch({ type: 'counterRequest/decrement' });
    };

    const interceptors = {
        request: (config) => {
            const tokenStr = GetToken();

            if (tokenStr !== null) {
                let token = JSON.parse(tokenStr);
                let dataToken = token.token;

                if (
                    config.data &&
                    typeof config.data === 'object' &&
                    config.data.get &&
                    (config.data.get('grant_type') === 'refresh_token' ||
                        config.data.get('grant_type') === 'password')
                ) {
                    return inc(), config;
                }

                config.headers.Authorization = `${dataToken.token_type}  ${dataToken.access_token}`;
                config.headers['Content-Type'] = 'application/json';
            }

            config.headers['Content-Type'] = 'application/json';
            let showLoader = !config.params?.notShowLoader ?? true;

            if (showLoader && !routesNotShowLoader.includes(config.url)) inc();
            return config;
        },

        errorRequest: (error) => (dec(), Promise.reject(error)),

        response: (response) => (dec(), response),

        errorResponse: (error) => {
            const originalRequest = error.config;
            if (
                error.response.status === 401 &&
                originalRequest.url === '/oauth/token' &&
                originalRequest.data === 'grant_type=refresh_token'
            ) {
                printToast({
                    severity: 'error',
                    summary: 'Sua sessão expirou! Por favor Logue novamente',
                });
                logout();
                dispatch({ type: 'SETUSER', value: null });
                return dec(), Promise.reject(error);
            }

            if (error.response.status === 401 && isExpiredToken() && !originalRequest._retry) {
                originalRequest._retry = true;
                let formData = new URLSearchParams();
                formData.append('grant_type', 'refresh_token');
                delete window.$http.defaults.headers.common['Content-Type'];
                window.$http.defaults.headers.common['Authorization'] = `Basic ${btoa(
                    `${process.env.REACT_APP_USERNAME_API}:${process.env.REACT_APP_PASSWORD_API}`
                )}`;
                return (
                    dec(),
                    window.$http
                        .post('/oauth/token', formData, {
                            withCredentials: true,
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                            },
                        })
                        .then((res) => {
                            let userlogado = JSON.parse(GetToken());
                            userlogado.token = res.data;
                            setToken(JSON.stringify(userlogado));

                            originalRequest.headers.Authorization = `${userlogado.token.token_type}  ${userlogado.token.access_token}`;
                            originalRequest.headers['Content-Type'] = 'application/json';

                            return window.$http(originalRequest);
                        })
                        .catch(() => Promise.reject(error))
                );
            }

            if (!error.response || error?.config?.ignoreReject) {
                return dec(), Promise.reject(error);
            }

            return axiosErrorShow(error, dec);
        },
    };

    Axios.interceptors.request.use(interceptors.request, interceptors.errorRequest);
    Axios.interceptors.response.use(interceptors.response, interceptors.errorResponse);

    return Axios;
};

export default useAxiosLoader;
